import { parse } from 'node-html-parser';
import { applyStyles } from './applyStyles';

const templateEmailAddWizardStyles = (template) => {
  const root = parse(template.body);

  const generalFontWrapper = root.querySelector('.font-wrapper');
  if (generalFontWrapper) {
    generalFontWrapper.setAttribute('style', applyStyles(template.wizardFormData.generalFontStyles, ''));
  }

  const discountBadgeElement = root.querySelector('.rlv-discount-badge');
  if (discountBadgeElement) {
    discountBadgeElement.setAttribute('style', applyStyles(template.wizardFormData.discountBadgeStyles, ''));
  }
  const productNameElement = root.querySelector('.productBlockProductTitle');
  if (productNameElement) {
    productNameElement.setAttribute('style', applyStyles(template.wizardFormData.productNameStyles, ''));
  }
  const productPriceElement = root.querySelector('.rlv-price-listPrice');
  if (productPriceElement) {
    productPriceElement.setAttribute(
      'style',
      applyStyles(template.wizardFormData.productPriceStyles, productPriceElement.getAttribute('style'))
    );
  }
  const productDiscountPriceElement = root.querySelector('.rlv-price-discountPrice');
  if (productDiscountPriceElement) {
    productDiscountPriceElement.setAttribute(
      'style',
      applyStyles(template.wizardFormData.productDiscountPriceStyles, '')
    );
  }
  const productPriceDiscountedElement = root.querySelector('.rlv-price-listPriceDiscounted');
  if (productPriceDiscountedElement) {
    productPriceDiscountedElement.setAttribute(
      'style',
      applyStyles(template.wizardFormData.productPriceDiscountedStyles, '')
    );
  }

  return root.toString();
};

export default templateEmailAddWizardStyles;
